import './caseFileSection.scss';

import { IDisplayFieldModel, IDisplaySectionModel } from '../../interfaces/IDisplaySectionModel';

import { DynamicSectionRenderer } from './DynamicSectionRenderer';
import { IUserModel } from '../../interfaces/IUser';
import { IValidation } from '../../interfaces/IError';
import { StaticSectionRenderer } from './StaticSectionRenderer';
import { useCaseFileContext } from '../../contexts/useCaseFileContext';
import { useMemo } from 'react';

function addPlaceholderFields(fields: IDisplayFieldModel[]): IDisplayFieldModel[] {
    const newFields: IDisplayFieldModel[] = [];
    let lastOrder = 0;
    fields.forEach((field) => {
        const sortOrderDiff = field.sortOrder - lastOrder;

        for (let i = 1; i < sortOrderDiff; i++) {
            newFields.push({ sortOrder: lastOrder + i } as IDisplayFieldModel);
        }

        newFields.push(field);
        lastOrder = field.sortOrder;
    });
    return newFields;
}

function splitFieldsIntoRows(
    fields: IDisplayFieldModel[],
    numColumns: number
): IDisplayFieldModel[][] {
    const fieldsWithPlaceholders = addPlaceholderFields(fields);

    const rows: IDisplayFieldModel[][] = [];

    let newRow: IDisplayFieldModel[] = [];
    fieldsWithPlaceholders.forEach((field) => {
        newRow.push(field);

        if (newRow.length === numColumns) {
            rows.push(newRow);
            newRow = [];
        }
    });

    if (newRow.length > 0) {
        rows.push(newRow);
    }

    return rows;
}

interface ICaseFileSectionProps {
    displayAsCondensed: boolean;
    isOpen: boolean;
    numberOfColumns: 2 | 3;
    parentKey?: string;
    section: IDisplaySectionModel;
    user: IUserModel;
    validation: IValidation;
}

export function CaseFileSection({
    displayAsCondensed,
    isOpen,
    numberOfColumns,
    parentKey,
    section,
    user,
    validation,
}: ICaseFileSectionProps) {
    const { isReadOnlyMode, zoneDefenseCounsels, zoneUsers } = useCaseFileContext();

    const rows = useMemo(
        () => splitFieldsIntoRows(section.fields ?? [], numberOfColumns),
        [section.fields]
    );

    return (
        <>
            {section.isStatic ? (
                <StaticSectionRenderer
                    isOpen={isOpen}
                    isReadOnlyMode={isReadOnlyMode}
                    section={section}
                    user={user}
                    zoneDefenseCounsels={zoneDefenseCounsels}
                    zoneUsers={zoneUsers}
                />
            ) : (
                <DynamicSectionRenderer
                    isOpen={isOpen}
                    numberOfColumns={numberOfColumns}
                    parentKey={parentKey}
                    rows={rows}
                    section={section}
                    user={user}
                    validation={validation}
                    displayAsCondensed={displayAsCondensed}
                />
            )}
        </>
    );
}
